import React from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUser } from '@clerk/clerk-react';
import { fetchUser } from 'actions';
import AuthLayout from './AuthLayout';
import RegistrationForm from './RegistrationForm';

export const Register = () => {
  const { isSignedIn } = useUser();
  const dispatch = useDispatch();
  const { push } = useHistory();
  const { t } = useTranslation();
  const from = `/${t('roadmap')}`;
  return isSignedIn ? (
    <Redirect to={from} />
  ) : (
    <AuthLayout>
      <RegistrationForm
        onRegister={() => {
          dispatch(fetchUser());
          push('/auth/add_classroom');
        }}
      />
    </AuthLayout>
  );
};

export default Register;
